import { Alert } from 'antd'
import { useTranslation } from 'react-i18next'
import { translateError } from '@/shared/api/errors'
import type { PreselectState } from './usePreselectedSubscriber'

interface PreselectNoticeProps {
  state: PreselectState
  /** Xabarni yopish — URL'dagi tanlov niyati ham o'chadi */
  onDismiss: () => void
}

/**
 * «Abonentlar»dan kelgan tanlov NEGA ochilmagani.
 *
 * ⚠️ BO'SH KARTOCHKA CHIZILMAYDI. Havola bilan kelgan odam abonentni
 * ALLAQACHON tanlagan; ekran esa uni ko'rsatmasa, yagona to'g'ri javob
 * — sababini aytish. «Abonentni tanlang» degan odatiy bo'sh holat bu
 * yerda YOLG'ON bo'lardi: tanlangan edi, panel topa olmadi.
 *
 * ⚠️ `translateError` — server matni bilan: 403 («bu abonent sizga
 * ochilmagan») va 500 butunlay boshqa ish talab qiladi va ularni
 * bitta «topilmadi» ga yig'ish noto'g'ri yo'l ko'rsatardi.
 */
export function PreselectNotice({ state, onDismiss }: PreselectNoticeProps) {
  const { t } = useTranslation()

  if (state.kind === 'idle' || state.kind === 'found') return null

  if (state.kind === 'loading') {
    return (
      <Alert
        style={{ marginBottom: 12 }}
        type="info"
        showIcon
        message={t('cashdesk.preselect.loading', { login: state.login })}
      />
    )
  }

  if (state.kind === 'missing') {
    return (
      <Alert
        style={{ marginBottom: 12 }}
        type="warning"
        showIcon
        closable
        onClose={onDismiss}
        message={t('cashdesk.preselect.missingTitle', { login: state.login })}
        description={t('cashdesk.preselect.missingText')}
      />
    )
  }

  return (
    <Alert
      style={{ marginBottom: 12 }}
      type="error"
      showIcon
      closable
      onClose={onDismiss}
      message={t('cashdesk.preselect.failedTitle', { login: state.login })}
      description={translateError(state.error, t)}
    />
  )
}
